import {
  FormControl,
  FormHelperText,
  Typography,
  useTheme,
} from "@mui/material";
import PriceDetailsCash from "./price-details-cash";
import PriceDetailsInstallements from "./price-details-installements";
import { Controller, UseFormReturn, useWatch } from "react-hook-form";
import {
  ToggleableRadio,
  ToggleableRadioGroup,
} from "@/modules/common/components/ui-kit/inputs/togglable-radio-group";

export interface PriceDetailsFormProps {
  form: UseFormReturn<any>;
  namePrefix?: string;
  extraFields?: boolean;
}

export default function PriceDetailsForm({
  form,
  namePrefix = "",
  extraFields = false,
}: PriceDetailsFormProps) {
  const theme = useTheme();

  const fieldName = (field: string = "") =>
    namePrefix ? `${namePrefix}.${field}` : field;

  const paymentType = useWatch({
    control: form.control,
    name: fieldName("paymentType"),
  });

  const renderPriceDetails = () => {
    switch (paymentType) {
      case "cash":
        return <PriceDetailsCash form={form} namePrefix={namePrefix} />;
      case "installments":
        return (
          <PriceDetailsInstallements
            form={form}
            namePrefix={namePrefix}
            extraFields={extraFields}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <Typography sx={theme.nawy.typography.english.variants.body.md.regular}>
        Price details
      </Typography>
      <Controller
        control={form.control}
        name={fieldName("paymentType")}
        render={({ field, fieldState }) => (
          <FormControl component="fieldset" error={!!fieldState.error}>
            <ToggleableRadioGroup {...field} row>
              <ToggleableRadio value="cash" label="Cash" />
              <ToggleableRadio value="installments" label="Installments" />
            </ToggleableRadioGroup>
            {fieldState.error && (
              <FormHelperText>{fieldState.error.message}</FormHelperText>
            )}
          </FormControl>
        )}
      />
      {renderPriceDetails()}
      <Controller
        control={form.control}
        name={namePrefix}
        render={({ fieldState }) => (
          <>
            {fieldState.error && (
              <FormHelperText error>
                {fieldState.error?.root?.message}
              </FormHelperText>
            )}
          </>
        )}
      />
    </>
  );
}
